import axiosTokenInstance from 'services/api/backoffice';
import { PURCHASE_ORDER_LIST_IPB, PURCHASE_ORDER_LIST_IPB_ERROR } from '_models/redux/types';

// Action function

export const purchaseOrderListIpbAction =
  (page = 1, size = 10, filters = {}) =>
  async (dispatch) => {
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`/api/ipb/orders?`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: PURCHASE_ORDER_LIST_IPB,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: PURCHASE_ORDER_LIST_IPB_ERROR,
        payload: e || {},
      });
    }
  };
